<script setup lang="ts">
/**
 * The chrome's identity region: the page title with an optional subtitle.
 * Purely presentational — values flow in from `usePageChrome` via the shell.
 */
defineProps<{
  title?: string | null
  subtitle?: string | null
  prominent?: boolean
}>()
</script>

<template>
  <div
    v-if="title || subtitle"
    class="chrome-title"
    :class="{ 'chrome-title--prominent': prominent }"
  >
    <span v-if="title" class="chrome-title__primary">{{ title }}</span>
    <span v-if="subtitle" class="chrome-title__subtitle">{{ subtitle }}</span>
  </div>
</template>

<style scoped>
.chrome-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  line-height: 1.2;
}

.chrome-title--prominent {
  padding-right: 18px;
}

.chrome-title__primary {
  font-size: 15px;
  font-weight: 600;
  color: var(--theme-on-surface, rgba(255, 255, 255, 0.92));
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chrome-title--prominent .chrome-title__primary {
  font-size: 26px;
  font-weight: 650;
}

.chrome-title__subtitle {
  font-size: 12px;
  font-weight: 400;
  color: var(--theme-text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
